import { Link, NavLink, useNavigate } from 'react-router-dom';
import { MagnifyingGlass, ShoppingBagOpen, Storefront, Package } from '@phosphor-icons/react';
import { useState } from 'react';
import { useCart } from '@/context/CartContext';
import { useSettings } from '@/context/SettingsContext';
import BrandLogo from '@/components/shop/BrandLogo';
import { NAV } from '@/constants/testIds';

export default function Header() {
  const { count, setCartOpen } = useCart();
  const { settings } = useSettings();
  const navigate = useNavigate();
  const [q, setQ] = useState('');

  const submitSearch = (e) => {
    e.preventDefault();
    const term = q.trim();
    if (term) navigate(`/shop?q=${encodeURIComponent(term)}`);
  };

  return (
    <header className="sticky top-0 z-40 bg-white/85 backdrop-blur-xl border-b border-stone-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center gap-3 sm:gap-6">
        <Link to="/" data-testid={NAV.logo} className="flex items-center gap-2 shrink-0">
          <BrandLogo />
          <span className="hidden sm:block font-heading font-bold text-xl tracking-tight text-stone-900">{settings?.store_name || 'MyZippyKart'}</span>
        </Link>

        <form onSubmit={submitSearch} className="flex-1 max-w-2xl">
          <div className="relative">
            <MagnifyingGlass size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-stone-400" />
            <input
              data-testid={NAV.searchInput}
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search for fruits, vegetables, groceries..."
              className="w-full h-11 pl-11 pr-4 rounded-full bg-stone-100 border border-transparent focus:bg-white focus:border-stone-300 focus:outline-none transition-all text-sm placeholder:text-stone-400"
            />
          </div>
        </form>

        <nav className="hidden md:flex items-center gap-1">
          <NavLink to="/shop" className={({isActive}) => `px-3 py-2 rounded-full text-sm font-medium transition-colors ${isActive ? 'text-olive-700 bg-olive-50' : 'text-stone-600 hover:text-stone-900 hover:bg-stone-100'}`}>
            <span className="flex items-center gap-1.5"><Storefront size={16} weight="duotone" /> Shop</span>
          </NavLink>
          <NavLink to="/marketplace" data-testid="nav-marketplace" className={({isActive}) => `px-3 py-2 rounded-full text-sm font-medium transition-colors ${isActive ? 'text-olive-700 bg-olive-50' : 'text-stone-600 hover:text-stone-900 hover:bg-stone-100'}`}>
            <span className="flex items-center gap-1.5"><Storefront size={16} weight="duotone" /> Local stores</span>
          </NavLink>
          <NavLink to="/track" className={({isActive}) => `px-3 py-2 rounded-full text-sm font-medium transition-colors ${isActive ? 'text-olive-700 bg-olive-50' : 'text-stone-600 hover:text-stone-900 hover:bg-stone-100'}`}>
            <span className="flex items-center gap-1.5"><Package size={16} weight="duotone" /> Track</span>
          </NavLink>
        </nav>

        <button
          data-testid={NAV.cartButton}
          onClick={() => setCartOpen(true)}
          className="relative h-11 w-11 rounded-full bg-stone-900 text-white hover:bg-stone-800 transition-colors grid place-items-center shrink-0"
          aria-label="Open cart"
        >
          <ShoppingBagOpen size={20} weight="duotone" />
          {count > 0 && (
            <span data-testid={NAV.cartBadge} className="absolute -top-1 -right-1 min-w-[20px] h-5 px-1 rounded-full bg-terracotta-600 text-white text-[10px] font-bold grid place-items-center">
              {count}
            </span>
          )}
        </button>
      </div>
    </header>
  );
}
